import { createContext } from 'react'
import { type ConnectedWallet } from '@/hooks/wallets/useOnboard'
import { type Eip1193Provider } from 'ethers'

export type SignerWallet = {
  provider: Eip1193Provider | null
  address: string
  chainId: string
  isSafe?: boolean
}

export type WalletContextType = {
  connectedWallet: ConnectedWallet | null
  signer: SignerWallet | null
  setSignerAddress: (address: string | undefined) => void
}

export const WalletContext = createContext<WalletContextType | null>(null)
